import React from 'react';
import { DisclaimerText } from '@yme/atoms/disclaimer-text';
import { useWindowSize } from '@yme/hooks/index';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { ArrowNav } from './ArrowNav';
import { HeaderCarouselStyled } from './styled';
export function HeaderCarouselDefault(props) {
    const { isArrowNavigationVisible = false, isArrowNavigationVisibleOnTablet = false, arrowTitles, isRightToLeft, counts, titleCarousel, activeItem, onClickPrevItem, onClickNextItem, indexOfCount, infoText, } = props;
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const isVisibleCondition = isArrowNavigationVisibleOnTablet
        ? !isMobileView
        : isInfiniteDesktopView;
    const isArrowVisible = isArrowNavigationVisible && isVisibleCondition && Boolean(counts);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderCarouselStyled, { isRightToLeft: isRightToLeft },
            titleCarousel && React.createElement(HeadingLevel2, null, titleCarousel),
            isArrowVisible && (React.createElement(ArrowNav, { activeItem: activeItem, isRightToLeft: isRightToLeft, onClickPrevItem: onClickPrevItem, onClickNextItem: onClickNextItem, indexOfCount: indexOfCount, titlePrev: arrowTitles.titlePrev, titleNext: arrowTitles.titleNext }))),
        infoText && (React.createElement(HeaderCarouselStyled, { isRightToLeft: isRightToLeft },
            React.createElement(DisclaimerText, { disclaimerText: infoText, colorText: colorCoreBlack300 })))));
}
HeaderCarouselDefault.displayName = 'HeaderCarouselDefault_Carousel';
